<template>
  <div
    :am-mode="isActive ? 'edit' : 'show'"
    :am-image-item="`
      ${
        !imgCount
        ? 'disabled'
        : ''
      }
    `"
    @click="editMode()"
    v-click-outside="showMode"
    @keyup.esc="showMode"
    tabindex="1"
  >
    <div
      :am-edit="isActive && isOpenModal ? 'open' : isActive ? '' : null"
      :am-show="isActive ? null : ''"
    >
      <div class="_display:flex _flex-wrap:wrap">
        <i-card
          am-img-tag-card
          v-for="side in data.data.sides"
          :key="side"
          class="_text-align:center _margin-right:1/2"
          @click="isActive ? open(side) : null"
        >
          <span>{{ imgCount }}</span>
          <svg
            v-if="isActive"
            viewBox="0 0 24 24"
            am-icon="color"
            am-icon-load
          >
            <use xlink:href="@/assets/icons.svg#open-modal" x="0" y="0" width="24" height="24" />
            <rect x="0" y="0" width="24" height="24" fill="transparent"></rect>
          </svg>
        </i-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'ImageItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isActive: false,
    isOpenModal: false
  }),
  computed: {
    imgCount () {
      let count = this.data.data.imgCount || 0
      const keyPart = `${this.data.side || this.data.sides[0]}_${this.data.type}_${this.data.data.part_id}`
      if (this.$store.state.parts.changedImages[this.$route.params.subtable]) {
        for (const key in this.$store.state.parts.changedImages[this.$route.params.subtable]) {
          if (key.includes(keyPart)) count = count + 1
        }
      }
      const deleted = this.$store.state.parts.changedParts[this.$route.params.subtable]?.[this.data.data.part_id]?.allData?.delete_image_ids
      if (deleted) {
        deleted.forEach(el => {
          if (el.side === (this.data.side || this.data.sides[0]) && el.type === this.data.type) {
            count = count - 1
          }
        })
      }
      return count
    }
  },
  methods: {
    showMode () {
      this.isActive = false
    },
    editMode () {
      if (this.data.data.sides.length === 1) {
        this.open(this.data.data.sides[0])
      } else {
        this.isActive = true
        this.$emit('editing', this.data.index)
      }
    },
    ...mapMutations('parts', ['setImageModal']),
    open (side) {
      this.setImageModal({ open: true, data: this.data, side: side })
    }
  }
}
</script>

<style lang="scss">
[am-img-tag-card] {
  position: relative;
  [am-icon-load] {
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
  }
}
[am-image-item] {
  .card {
    ----font-size: var(--font-size--md);
    transition: all var(--transition-duration) var(--transition-easing);
    cursor: pointer;

    &.-light {
      ----background: var(--color--secondary-10);
      ----border-color: var(--color--secondary);
      ----color: var(--color--secondary);
      &:hover { ----background: var(--color--secondary-15); }
    }

    &.-dark {
      ----background: var(--color--secondary-60);
      ----border-color: var(--color--secondary-10);
      ----color: var(--color--secondary-10);
      &:hover { ----background: var(--color--secondary-55); }
    }
  }
  [am-edit~='open'] {
    z-index: 2 !important;
  }
}
[am-image-item~='disabled'] {
  .card {
    &.-light {
      ----background: var(--color--dark-10);
      ----border-color: var(--color--dark);
      ----color: var(--color--dark);
      &:hover { ----background: var(--color--dark-15); }
    }

    &.-dark {
      ----background: var(--color--dark-60);
      ----border-color: var(--color--dark-10);
      ----color: var(--color--dark-10);
      &:hover { ----background: var(--color--dark-55); }
    }
  }
}
</style>
